















































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import moment from "moment";

import {
  FiltroServicosModel,
  SolicitacaoModel,
  FinalizarSolicitacaoModel,
  statusList,
  ServicoDetalhadoModel,
  DadosClienteModel
} from "@/models/solicitacoes";
import DetalheSolicitacao from "./DetalheSolicitacao.vue";

import { tipoServicoList } from "@/models/solicitacoes/TipoServicoModel";

import { servicoService } from "@/service/ServicoService";

import { DadosModal } from "@/components/modal/DadosModal";
import GsModal from "@/components/modal/GsModal.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

import { servicoModule } from "@/store/servico/ServicoModule";
import { TipoModalEnum } from "@/components/modal/TipoModalEnum";

@Component({
  components: {
    GsModal,
    GsModalDialog,
    ValidationObserver,
    ValidationProvider,
    DetalheSolicitacao
  }
})

export default class AcompanhamentoSolicitacoes extends Vue {
  $refs!: {
    filtroObserver: InstanceType<typeof ValidationObserver>;
    motivoCancelamentoObserver: InstanceType<typeof ValidationObserver>;
    acceptObserver: InstanceType<typeof ValidationObserver>;
  };

  cabecalho = [
    { text: "Data", value: "data", sortable: false, width: "15%" },
    { text: "Prestador", value: "prestador", sortable: false },
    {
      text: "Número do serviço",
      value: "numeroServico",
      sortable: false,
      width: "15%"
    },
    { text: "Serviço solicitado", value: "descricaoServico", sortable: false },
    { text: "Situação", value: "status", sortable: false, width: "15%"  },
    { text: "Ações", value: "actions", width: "15%", sortable: false }
  ];
  
  _timerId: any = null;
  tempoAtualizacaoPagina: number = 10000;

  reenviarServico = false;
  idPrestadorAceitar = 0;
  idServicoAceitar = 0;
  nomeMotorista = "";
  placaVeiculo = "";
  tempoEstimado = "";

  // Dialog
  showDialog = false;
  dialogType = "";
  dialogTitle = "";
  dialogMessage = "";
  loading = false;

  // Accept Dialog
  showAcceptDialog = false;

  listaStatus = statusList;
  listaTipoServico = tipoServicoList;

  isCancelar: boolean = false;
  isFinalizar: boolean = false;

  error = false;
  errorMessage = "";
 
  dadosModal: DadosModal = DadosModal.defaultValue();
  
  detalheSolicitacao: ServicoDetalhadoModel | null = null;
  dadosCliente: DadosClienteModel | null = null;
  resultado: SolicitacaoModel[] = [];

  servicoAFinalizar: FinalizarSolicitacaoModel = {
    idServico: undefined,
    idPrestador: undefined
  };

  filtro: FiltroServicosModel = {
    dataAte: moment().format("YYYY-MM-DD"),
    dataDe: moment()
      .add(-1, "day")
      .format("YYYY-MM-DD"),
    paginacao: { 
      itemsPerPage: 15,
      page: 1,
      itemsLength: 0
    }
  };

  descricaoStatus(status: string) {
    let descricao = "";

    statusList.filter(statusStatic => {
      statusStatic.valor.forEach(valor => {
        if (status == valor) {
          descricao = statusStatic?.descricao;
        }
      });
    });
    return descricao;
  }

  mounted() {
    if(this.$route.params.status && this.$route.params.tipo) {
      let statusTela =  this.$route.params.status as unknown as Array<string>;
      this.filtro.dataDe = '';
      this.filtro.dataAte = '';
      this.filtro.tipoServico = this.$route.params.tipo;
      this.filtro.status = statusTela;
    }

    this.pesquisar();
    this._timerId = setInterval(this.pesquisar, this.tempoAtualizacaoPagina); 
  }

  destroyed() {
    clearInterval(this._timerId);
  }

  @Watch("filtro.paginacao.page")
  @Watch("filtro.paginacao.itemsPerPage")
  observarPaginacao() {
   this.getData();
  }


  get btnColor() {
    return this.dialogType == 'SUCCESS' ? '#00CD96' : 'error';
  }

  get btnText() {
    return this.dialogType == 'SUCCESS' ? 'Ok, entendi' : 'Fechar';
  }

  get dialogImg() {
    return this.dialogType == 'SUCCESS' ? 'success.png' : 'error.png';
  }

  exibirFinalizarServico(servico: SolicitacaoModel) {
    return (
      servico.status == "ACEITO" &&
      servico.statusServico != "PENDENTE_APROVACAO" &&
      servico.statusServico != "FINALIZADO" &&
      servico.statusServico != "AGUARDANDO"
    );
  }

  isReenvioSolicitacao(servico: SolicitacaoModel): boolean {
    return servico.aceitaReenvioSolicitacao;
  }

  isNewSolicitation(servico: SolicitacaoModel): boolean {
    return servico.status === 'AGUARDANDO';
  }

  pesquisar() {
    this.filtro.paginacao.page = 1;
    this.getData();
  }

  cancelar() {
    this.dadosModal.aberto = false;
    this.isCancelar = false;
    this.isFinalizar = false;
  }

  getData() {
    this.error = true;
    this.errorMessage = "";
    if (
      !this.filtro.tipoServico &&
      !this.filtro.numeroServico &&
      !this.filtro.status &&
      (!this.filtro.dataDe || !this.filtro.dataAte)
    ) {
      this.$refs.filtroObserver.setErrors({
        status: "É necessário informar pelo menos um filtro"
      });
    } else {
      this.loading = true;
      servicoModule
        .obterSolicitacoes(this.filtro)
          .then(res => {
            this.resultado = servicoModule.resultadoSolicitacoes?.servicos || [];
            this.filtro.paginacao.itemsLength = 0;
          })
          .catch(err => {
            console.error(err);
            this.error = true;
            this.errorMessage = "Ocorreu uma falha ao buscar as solicitações.";
          })
          .finally(() => {
            this.filtro.paginacao.itemsLength =
            servicoModule.resultadoSolicitacoes?.paginacao.itemsLength || 0;
            this.loading = false;
          });
    }
  }

  detalhes(solicitacao: SolicitacaoModel) {
    this.fecharModal();

    this.$router.push({
      name: "DetalheSolicitacao",
      params: { id: solicitacao.idServico.toString(), 
          idPrestador: solicitacao.idPrestador.toString(), statusServico: solicitacao.status }
    });
  }

  fecharModal() {
    const tipo = this.dadosModal.titulo;
    this.detalheSolicitacao = null;
    this.dadosCliente = null;
    this.dadosModal = DadosModal.defaultValue();
    this.servicoAFinalizar = {};
    if (tipo == "Sucesso") {
      this.pesquisar();
    }
  }

  solicitarFinalizarServico(servico: SolicitacaoModel) {
    this.fecharModal();

    this.isFinalizar = true;

    this.servicoAFinalizar = {
      idServico: servico.idServico,
      idPrestador: servico.idPrestador
    };
    this.dadosModal.fullscreen = false;
    this.dadosModal.titulo = "Finalizar da Solicitação";
    this.detalheSolicitacao = null;
    this.dadosModal.tipo = TipoModalEnum.PADRAO;
    this.dadosModal.aberto = true;
    this.dadosModal.largura = "700";
  }

  solicitarCancelarServico(servico: SolicitacaoModel) {
    this.fecharModal();

    this.isCancelar = true;

    this.servicoAFinalizar = {
      idServico: servico.idServico,
      idPrestador: servico.idPrestador
    };
    this.dadosModal.fullscreen = false;
    this.dadosModal.titulo = "Cancelar Solicitação";
    this.detalheSolicitacao = null;
    this.dadosModal.tipo = TipoModalEnum.PADRAO;
    this.dadosModal.aberto = true;
    this.dadosModal.largura = "600";
  }

  recusarServico(servico: SolicitacaoModel) {
    servicoService
      .recusarSolicitacao(
        servico.idServico,
        servico.idPrestador
      )
      .then(res => {
        this.openDialog(
          'Sucesso',
          'Serviço recusado com sucesso.',
          'SUCCESS'
        );
      })
      .catch(err => {
        this.openDialog(
          'Erro',
          'Ocorreu um erro ao efetuar a recusa do serviço.',
          'ERROR'
        );
    });
  }

  finalizarServico() {
    if (this.servicoAFinalizar) {
      this.alterarStatusAtendidoComSucesso();

      servicoService
        .finalizarServico(this.servicoAFinalizar)
        .then(res => {
          this.fecharModal();
          this.dadosModal.fullscreen = false;
          this.detalheSolicitacao = null;
          this.dadosModal.titulo = "Sucesso";
          if (this.isFinalizar) {
            this.dadosModal.mensagem = `Serviço finalizado com sucesso.`;
          } else {
            this.dadosModal.mensagem = `Esse processo invalidará qualquer cobrança referente a esse atendimento.
            Estaremos encaminhando à Central para que acione outro Prestador de Serviço para esse atendimento.`;
          }
          this.dadosModal.largura = "600";
          this.dadosModal.aberto = true;
          this.isFinalizar = false;
          this.isCancelar = false;

          this.dadosModal.tipo = TipoModalEnum.PADRAO;
        })
        .catch(err => {
          this.fecharModal();
          this.isFinalizar = false;
          this.isCancelar = false;
          this.dadosModal.fullscreen = false;
          this.detalheSolicitacao = null;
          this.dadosModal.titulo = "Erro";
          if (this.isFinalizar) {
            this.dadosModal.mensagem =
              "Ocorreu um erro ao efetuar a finalização do serviço";
          } else {
            this.dadosModal.mensagem =
              "Ocorreu um erro ao efetuar cancelar o serviço";
          }
          this.dadosModal.aberto = true;
          this.dadosModal.tipo = TipoModalEnum.ERRO;
        });
    }
  }

  cancelarServico() {
    this.$refs.motivoCancelamentoObserver.validate().then(valid => {
      if (valid) {
        this.alterarStatusAtendidoComSucesso();
        this.finalizarServico();
      }
    });
  }

  alterarStatusAtendidoComSucesso() {
    if (this.isFinalizar) {
      this.servicoAFinalizar.atendidoComSucesso = true;
    } else {
      this.servicoAFinalizar.atendidoComSucesso = false;
    }
  }

  private openDialog(title: string, message: string, dialogType: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  aceitarSolicitacao(servico: SolicitacaoModel) {
    this.showAcceptDialog = true;
    this.idServicoAceitar = servico.idServico;
    this.idPrestadorAceitar = servico.idPrestador;
    this.reenviarServico = false;
  }

  reenviarSolicitacao(servico: SolicitacaoModel) {
    this.showAcceptDialog = true;
    this.idServicoAceitar = servico.idServico;
    this.idPrestadorAceitar = servico.idPrestador;
    this.reenviarServico = true;
  }

  aceitarSolicitacaoPeloAdministrador() {

    if (this.reenviarServico) {
      servicoService.reenviarSolicitacao(
        this.idServicoAceitar,
        this.idPrestadorAceitar,
        this.nomeMotorista,
        this.placaVeiculo,
        this.tempoEstimado
      )
      .then(res => {
        this.openDialog(
          'Sucesso',
          'Serviço reenviado e aceito com sucesso.',
          'SUCCESS'
        );
      })
      .catch(err => {
        this.openDialog(
          'Erro',
          'Ocorreu um erro ao efetuar o reenvio do serviço.',
          'ERROR'
        );
      });
    } else {
      servicoService.aceitarSolicitacao(
        this.idServicoAceitar,
        this.idPrestadorAceitar,
        this.nomeMotorista,
        this.placaVeiculo,
        this.tempoEstimado
      )
      .then(res => {
        this.openDialog(
          'Sucesso',
          'Serviço aceito com sucesso.',
          'SUCCESS'
        );
      })
      .catch(err => {
        this.openDialog(
          'Erro',
          err.message,
          'ERROR'
        );
      });
    }
  }

  closeDialog() {
    if (this.dialogType == 'SUCCESS') {
      this.pesquisar();
    }
    this.showDialog = false;
  }

  closeAcceptDialog(accept = false) {
    if (accept) {
      this.$refs.acceptObserver.validate()
        .then((valid) => {
          if (valid) {
            this.aceitarSolicitacaoPeloAdministrador();
            this.showAcceptDialog = false;
          }
        })
    } else {
      this.showAcceptDialog = false;
    }
  }



}
